import React from 'react';

import {MinimalFreezeThawInfo} from 'constants/SampleStatusConstants';
import TextValue from 'ui-library/TextValue';

export default function FreezeThawCountCell({
  freezeThawInfo,
}: {
  freezeThawInfo?: MinimalFreezeThawInfo;
}): JSX.Element {
  return (
    <TextValue
      value={freezeThawInfo?.isTrackingEnabled ? freezeThawInfo.freezeThawCount : null}
      placeholder={freezeThawInfo?.isTrackingEnabled ? 'Not specified' : 'N/A'}
    />
  );
}
